import { Outlet } from 'react-router-dom';
import AppHeader from './layout/AppHeader.jsx';

/**
 * Minimal module shell: the BOS+ brand header (links back to /dashboard) around
 * an <Outlet/>. Used by top-level modules that have no sidebar of their own
 * (Wiki, Events). `flush` drops the page padding and width cap for modules that
 * bring their own full-bleed layout, like the wiki's two-panel space view.
 */
export default function AppShell({ flush = false }) {
  return (
    <div className="hr-shell">
      <AppHeader />
      <main className="hr-main" style={flush ? { padding: 0, maxWidth: 'none' } : undefined}>
        <Outlet />
      </main>
    </div>
  );
}
